import { Component, OnDestroy } from '@angular/core';
import { EditAutomaticPaymentFlowService } from './services/edit-automatic-payments-flow-service';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-edit-automatic-payments',
    templateUrl: './edit-automatic-payments.component.html',
    styleUrls: ['./edit-automatic-payments.component.scss'],
    imports: [RouterOutlet]
})
export class EditAutomaticPaymentsComponent implements OnDestroy {
    constructor(
        private editPaymentFlow: EditAutomaticPaymentFlowService
    ) { }

    ngOnDestroy(): void {
        this.editPaymentFlow.clear();
    }
}
